import React from 'react';
import { useTranslation } from 'react-i18next';

const InvoiceLineCalculationHeader = () => {
  // translations
  const tLabels = useTranslation("invoice\\invoice").t;

  return (
    <div className="d-none d-sm-block text-muted font-weight-bold pr-5">
      <div className="row no-gutters align-items-center">
          <div className="col-12 col-sm-5 col-lg-6">
            {tLabels("invoiceLineCalculationHeader.description")}
          </div>
          <div className="col-12 col-sm-7 col-lg-6 pl-sm-3">
            <div className="row no-gutters align-items-center">
              <div className="col-sm-6 order-1 order-sm-0 text-right text-sm-left">
                {tLabels("invoiceLineCalculationHeader.timePeriod")}
              </div>
              <div className="col-sm-6 text-right pr-2 pr-sm-0 text-nowrap">
                {tLabels("invoiceLineCalculationHeader.totalWithoutTax")}
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default InvoiceLineCalculationHeader;
